<template>
  <v-container>
    <strong class="font-weight-bold" style="font-size: 28px;">Bem-vindo!</strong>
    <br>
    <span class="subtitle-1">No Infohidro, a cada tema você encontra dados confiáveis para a gestão da segurança hídrica no Paraná.</span>

    <v-list color="transparent">
      <v-list-item three-line class="d-none d-sm-flex my-6 primary darken-1 list-item" link @click="goToPage(item.link)" v-for="(item, index) in authorizedModules" :key="index">
        <v-list-item-icon>
          <v-icon color="secondary lighten-1" size="80">{{item.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold" style="font-size: 32px;">
            {{item.title}}
          </v-list-item-title>
          <v-list-item-subtitle style="font-size: 16px;">
            {{item.subtitle}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon class="align-self-center">
          <v-icon size="50">mdi-chevron-right</v-icon>
        </v-list-item-icon>
      </v-list-item>

      <v-list-item three-line class="d-flex d-sm-none my-6 primary darken-1 list-item" link @click="goToPage(item.link)" v-for="(item, index) in authorizedModules" :key="'mobilelist-'+index">
        <v-list-item-icon class="align-self-center">
          <v-icon color="secondary lighten-1" size="40">{{item.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold" style="font-size: 18px;">
            {{item.title}}
          </v-list-item-title>
          <v-list-item-subtitle style="font-size: 14px;">
            {{item.subtitle}}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon class="align-self-center">
          <v-icon size="30">mdi-chevron-right</v-icon>
        </v-list-item-icon>
      </v-list-item>
    </v-list>

  </v-container>
</template>

<script>
import routes from '../router/routes';
export default {
  name: "Home",
  data:()=>({
    modules:[
    {
        link: routes.reservoirs.path,
        icon: 'icon-infohidro-abastecimento',
        title: routes.reservoirs.title,
        subtitle: 'Dados de reservatórios e do sistema de abastecimento de água.',
        authorize: routes.reservoirs.authorize,
      },
      {
        link: routes.monitoring.path,
        icon: 'mdi-shield-outline',
        title: routes.monitoring.title,
        subtitle: 'Dados de previsão para as bacias de manancias e a situação  dos reservatórios.',
        authorize: routes.monitoring.authorize
      },
      {
        link: routes.conservation.path,
        icon: 'mdi-barley',
        title: routes.conservation.title,
        subtitle: 'Dados de monitoramento ambiental, estações e reservatórios.',
        authorize: routes.conservation.authorize,
      },
      {
        link: routes.indicators.path,
        icon: '$Indicator',
        title: routes.indicators.title,
        subtitle: 'Dados de indicadores ambientais.',
        authorize: routes.indicators.authorize,
      },
      {
        link: routes.effluents.path,
        icon: 'mdi-water-remove-outline',
        title: routes.effluents.title,
        subtitle: 'Localização e dados de previsão dos corpos receptores.',
        authorize: routes.effluents.authorize,
      },
      {
        link: routes.stationsData.path,
        icon: 'mdi-file-document-outline',
        title: routes.stationsData.title,
        subtitle: 'Relatórios das estações hidrológicas e pluviométricas.',
        authorize: routes.stationsData.authorize,
      },
      {
        link: routes.undergroundWaters.path,
        icon: 'mdi-waves',
        title: routes.undergroundWaters.title,
        subtitle: 'Localização e dados de águas subterrâneas.',
        authorize: routes.undergroundWaters.authorize,
      },
    ]
  }),
  computed:{
    currentUserRoles(){
      const currentUser = this.$store.getters.currentUser;
      if(!currentUser) return [];
      const { roles } = currentUser.attributes;

      if(roles){
        const listRoles = Array.isArray(roles) ? roles : [roles];

        return listRoles;
      }
      return [];
    },
    authorizedModules(){
      return this.modules.filter((module)=> this.currentUserRoles.some(r => module.authorize.includes(r)));
    },
  },
  methods:{
    goToPage(routePath){
      this.$router.push(routePath);
    }
  }
}
</script>

<style scoped>
  .list-item{
    transition: transform 0.5s;
  }
  .list-item:hover{
    transform: translateX(10px);
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(215, 215, 215, 0.06) 100%);
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(40px);
  }
</style>

